export const SETTINGS = {
    REMOTERESOURCES: {
        API: {
            ROOT_URL: process.env.REACT_APP_API_ROOT_URL,
        },
        WF: {
            ROOT_URL: process.env.REACT_APP_API_WORKFLOWAPI_ROOT_URL,
        },
        MANAGEMENTAPI: {
            ROOT_URL: process.env.REACT_APP_API_MANAGEMENTAPI_ROOT_URL,
        },
    },
    AZURE: {
        APPINSIGHT_INSTRUMENTATIONKEY: process.env.REACT_APP_APPINSIGHT_INSTRUMENTATIONKEY
    },
    ADOBE:{
        //T-A-P, alles onder db365.eu
        //API_KEY: 'ef5e4eb445864210bc25ca9076d922db',
        //localdev (localhost)
        //API_KEY: '74df343354754a7298999ede9ed2be1f',
        API_KEY: process.env.REACT_APP_ADOBE_APIKEY
    }
}